<template>
    <div v-if="styles" class="styles" :class="{ mobile: $store.getters.isMobile }">
        <div class="grid-col">
            <div class="style flex-row" :key="item.key" v-for="item in items">
                <span class="key flex-wrap">{{ item.key | translate }}</span>
                <span class="value flex-fill">{{ item.value }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import style from '@/assets/constants/style'

export default {
    name: 'Styles',
    props: ['styles', 'gender'],
    computed: {
        items() {
            if (!this.styles) return

            return [
                {
                    key: 'AGE',
                    value: this.styles.min_age + '~' + this.styles.max_age,
                },
                {
                    key: 'HEIGHT_TYPE',
                    value: this.styles.min_height + '~' + this.styles.max_height,
                    // style[this.gender === 0 ? 'MALE_HEIGHT_TYPE' : 'FEMALE_HEIGHT_TYPE'][this.styles.height_type],
                },
                {
                    key: 'FRIEND_TYPE',
                    value: style.FRIEND_TYPE[this.styles.friend_type],
                },
                {
                    key: 'SPEC_TYPE',
                    value: style.SPEC_TYPE[this.styles.spec_type],
                },
                {
                    key: 'SMOKING_TYPE',
                    value: style.SMOKING_TYPE[this.styles.smoking_type],
                },
            ]
        },
    },
}
</script>

<style lang="scss" scoped>
.styles {
    &.mobile {
        .key {
            font-size: 14px;
        }
        .value {
            font-size: 14px;
        }
    }
}
</style>
